const defaultApiUrl = process.env.NODE_ENV === 'development'
	? 'http://localhost:4000'
	: 'https://api.braineka.com';

export const API_URL = (process.env.REACT_APP_API_URL || defaultApiUrl).replace(/\/$/, '');
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LfRD8srAAAAAP3dpjpU3KGOzrOJbfgAGTx-KHdG';
